export const environment = {
  production: false,
  API_END_POINT: 'https://beta.docquityclinic.com',
  indonesiaDomain: 'https://beta.docquitycare.id',
  otherDomain: 'https://beta.docquitycare.com',
  hCaptchaSiteKey: '10000000-ffff-ffff-ffff-000000000001',
  env : 'UAT',
  hideRelevantFilesPharma: 'PHM914,PHM969',
  surgeryDateSupportedPharmaCodes: ["PHM678"]
};
